import { Box, Paper, Typography } from '@mui/material';
import parse from 'html-react-parser';
import React from 'react';

const infoBoxes = [
  {
    id: 2,
    content: [
      'Nemcsak a <strong>HOGYANT?</strong>, hanem a <strong>MIÉRTEKET!</strong> is feltárjuk.',
      '100% gyakorlati megvalósítás <strong>FÓKUSZ</strong>',
      'A legnagyobb szakértelemmel összeállított videók, amelyek részletesen megmutatják a folyamatokat, számodra is érthető és reprodukálható módon',
    ],
  },
  {
    id: 3,
    content: [
      '1000+ regisztráció',
      '4M+ megtekintés az ingyenes platformokon',
      '35K+ követő',
      'Számtalan családnak adunk lendületet, önbizalmat és tudást videóinkkal.',
      'Bebizonyítjuk, hogy Te is képes vagy függetlenedni!',
    ],
  },
  {
    id: 4,
    content: [
      'Szakértői támogatás',
      'Közösségünk tagjai számára Okleveles Agrármérnökként maximális szakértelemmel nyújtunk támogatást az állattartás, kertészet, kiveszőben lévő paraszti tudás terén.',
      'Vendégtanáraink pedig szakterületükön a legnagyobb hozzáértéssel adják át tudásukat.',
    ],
  },
];

export default function ResponsiveInfoBoxes() {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: 3,
        gridTemplateColumns: {
          xs: '1fr',
          sm: '1fr ',
          md: '1fr ',
          lg: '1fr 1fr 1fr',
        },
        p: 3,
      }}
    >
      {infoBoxes.map((box) => (
        <Paper
          key={box.id}
          elevation={3}
          sx={{
            p: 3,
            height: '100%',
            textAlign: 'left',
          }}
        >
          {box.content.map((text, index) => (
            <Typography key={index} variant='subtitle1' sx={{ mb: 1 }}>
              ✔ {parse(text)}
            </Typography>
          ))}
        </Paper>
      ))}
    </Box>
  );
}
